import { useState } from "react";
import AddSupplier from "./AddSupplier";
import Permission from "../RoleManagement/Permission";


const CreateSupplier = () => {

    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();

    const handleAddClick = () => {
        setSelectedRow({
            name: "",
            email: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            country: "",
            status: "internal",
            contact_person_name: "",
            supervisor_id: "",
            department_id: "",
            contact: "",
        });
        setShowOffcanvas(!showOffcanvas);
        setOperation("create")
    };

    return (
        <>
            <Permission access={"/addsupplier"}>
                <button onClick={() => handleAddClick()} className="btn-orange">Add Supplier Master</button>
            </Permission>
            <AddSupplier
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />
        </>
    );
}

export default CreateSupplier;